import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchHighlightActions, deleteHighlightAction } from "actions/highlightAction";
import { toggleconfirmationPopup, toggleNotification } from "actions/toggle";

import SearchForm from "./SearchForm";
import Table from "./Table";
import Pagination from "components/Pagination";

class HighlightActionIndex extends Component {
  componentDidMount() {
    this.props.fetchHighlightActions();

    this.search = {};
  }

  onSearchFormSubmit = data => {
    this.search = { [data.search_by]: data.search_term };
    this.props.fetchHighlightActions({ ...this.search });
  };

  onPaginationClick = page => event => {
    const { highlightActionURL: highlightAction_url } = this.props.match.params;
    this.props.fetchHighlightActions({ highlightAction_url, page, ...this.search });
  };

  handleHighlightActionDelete = id => event => {
    const { toggleconfirmationPopup } = this.props;
    toggleconfirmationPopup(true, {
      onClickDelete: () => {
        this.deleteHighlightActionProcess(id);
      },
      title: "Delete highlightAction",
      body: "Are you sure you want to delete this highlightAction?"
    });
  };

  deleteHighlightActionProcess(id) {
    const { toggleNotification, toggleconfirmationPopup, deleteHighlightAction, match } = this.props;
    const { highlightActionURL: highlightAction_url } = match.params;
    deleteHighlightAction(id, { highlightAction_url })
      .then(() => {
        this.props.fetchHighlightActions({ ...this.search });
        toggleNotification(true, { infoClassName: "is-success", message: "Delete HighlightAction Success" });
        toggleconfirmationPopup(false, {});
      })
      .catch(({ message }) => {
        toggleNotification(true, { infoClassName: "is-danger", message });
        toggleconfirmationPopup(false, {});
      });
  }

  render() {
    const { highlightActions } = this.props;

    return (
      <div>
        <div className="box">
          <SearchForm onSearchFormSubmit={this.onSearchFormSubmit} />
          <Table highlightActions={highlightActions} onClickDelete={this.handleHighlightActionDelete} />
          <Pagination
            onClick={this.onPaginationClick}
            currentPage={highlightActions.current_page}
            lastPage={highlightActions.last_page}
            range="4"
            modifyClasses="is-right"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authHighlightAction, highlightActions, confirmationPopupActive }) => ({
  authHighlightAction,
  highlightActions,
  confirmationPopupActive
});

export default connect(
  mapStateToProps,
  { fetchHighlightActions, deleteHighlightAction, toggleconfirmationPopup, toggleNotification }
)(HighlightActionIndex);



// WEBPACK FOOTER //
// ./src/pages/HighlightAction/Index/index.js